import { interaction, Separator, SizableText, XStack, Stack, YStack } from '@mythical/ui'
import { Plus } from '@tamagui/lucide-icons'
import { useState } from 'react'

import RichText from '../RichText'

type FaqProps = {
  question: string
  answer: string | string[]
}

const Faq = ({ question, answer }: FaqProps) => {
  const [open, setOpen] = useState(false)

  return (
    <YStack>
      <Stack tag="button" cursor="pointer" onPress={() => setOpen(!open)} {...interaction.opacity}>
        <XStack ai="center" gap="$3.5" pr="$2" py="$6" w="100%">
          <YStack f={1}>
            <SizableText
              size="$5"
              fontWeight="600"
              color="$fgPrimary"
            >
              {question}
            </SizableText>
          </YStack>

          <YStack
            ai="center"
            animation="quick"
            fs={0}
            jc="center"
            rotate={open ? '45deg' : '0deg'}
            w={24}
          >
            <Plus color="$fgPrimary" size={24} />
          </YStack>
        </XStack>
      </Stack>

      <YStack height={open ? 'auto' : 0} overflow="hidden">
        <YStack pb="$6">
          <RichText content={answer} />
        </YStack>
      </YStack>

      <Separator borderColor="$borderPrimary" />
    </YStack>
  )
}

export default Faq
